module.exports = __webpack_public_path__ + "img/loading.984381ca.gif";